import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useLang } from "@/i18n";

const makeIcon = (bg, size) =>
  L.divIcon({
    className: "",
    html: `<div style="width:${size}px;height:${size}px;border-radius:9999px;background:${bg};border:3px solid #FBF8F3;box-shadow:0 4px 14px rgba(47,41,36,.35)"></div>`,
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
  });

export default function AttractionsMap({ items, config }) {
  const { t } = useLang();
  const house = [parseFloat(config?.house_lat || 45.5907), parseFloat(config?.house_lng || 25.4612)];

  return (
    <div className="mt-14" data-testid="attractions-map-wrapper">
      <p className="text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-walnut flex items-center gap-3 mb-5">
        <span className="inline-block w-10 h-px bg-terracotta" />
        {t("att.map_title")}
      </p>
      <div className="overflow-hidden rounded-3xl border border-warm-grey/40 shadow-xl shadow-main/5" data-testid="attractions-map">
        <MapContainer center={house} zoom={10} scrollWheelZoom={false} style={{ height: 440, width: "100%", background: "#F5F0E8" }}>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={house} icon={makeIcon("#C67A5C", 22)}>
            <Popup>
              <strong>Imperfect House</strong>
              <br />
              {t("att.here")}
            </Popup>
          </Marker>
          {items
            .filter((a) => a.lat && a.lng)
            .map((a) => (
              <Marker key={a.id} position={[a.lat, a.lng]} icon={makeIcon("#66745C", 14)}>
                <Popup>
                  <strong>{a.name}</strong>
                  <br />
                  {String(a.distance_km).replace(".", ",")} km · {a.travel_time}
                </Popup>
              </Marker>
            ))}
        </MapContainer>
      </div>
    </div>
  );
}
